module.exports = __webpack_public_path__ + "img/1537295197.9bd99ffa.jpg";